import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import useStore from "../../store";
import Modal from "react-modal";
import Categories from "./Categories";
import Invoice from "../Invoice/Invoice";
import useTranslation from "../../hooks/useTranslation";
import get from "lodash/get";
import "./menuItems.css";

export default function MenuItems() {
  const { tr } = useTranslation();

  const { id } = useParams();

  const { company, setCompany, setCategories, showInvoice, setShowInvoice } = useStore(
    (state) => state
  );
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    if (id && !isFetched) fetchMenus();
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    fetchCompany();
    // eslint-disable-next-line
  }, []);

  async function fetchMenus() {
    axios({
      url: `${process.env.REACT_APP_API_URL}online-menu/${id}/menus`,
      params: {
        company_id: id,
        per_page: 100,
        time: new Date().getTime(),
        include: "children,file",
        filter: {
          online_menu_show: 1,
        },
      },
      method: "GET",
    })
      .then((response) => {
        if (response?.data?.data) {
          setCategories(response.data.data);
        }
        setIsFetched(true);
      })
      .catch(function (error) {
        console.log(error);
        setIsFetched(true);
      });
  }

  async function fetchCompany() {
    axios({
      url: `${process.env.REACT_APP_API_URL}online-menu/${id}/companies`,
      params: {
        include: "logo,paymentSystems,setting",
      },
      method: "GET",
    })
      .then((response) => {
        if (response?.data) {
          setCompany(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const instagram = get(company, 'instagram');
  const telegram = get(company, 'telegram');
  return (
    <div className="">
      <div className="">
        <Categories />

        {(instagram || telegram) && (
            <div className="social-network text-center my-15">
              <h4 className="text-sm font-semibold mb-2">
                {tr("Вы можете найти нас в социальных сетях.")}
              </h4>
              <div className="flex justify-center space-x-4">
                {instagram && (
                    <a
                        href={instagram} style={{color: "rgba(0,0,0,.6)"}}>
                      <i className="fab fa-instagram text-2xl"></i>
                    </a>
                )}
                {telegram && (
                    <a href={telegram} style={{color: "rgba(0,0,0,.6)"}}>
                      <i className="fab fa-telegram text-2xl"></i>
                    </a>
                )}
              </div>
            </div>
        )}

        <Modal isOpen={showInvoice} contentLabel={tr("Счет")}>
          <div
            onClick={() => setShowInvoice(false)}
            className="flex flex-row items-center justify-center absolute top-0 right-0 m-[10px] cursor-pointer "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="25"
              height="25"
              viewBox="0 0 50 50"
            >
              <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
            </svg>
          </div>
          <Invoice />
        </Modal>
      </div>
    </div>
  );
}
